import { useEffect } from 'react'
import { useBrandVisualKits } from 'hooks/queries/workspaces/useBrandVisualKits'
import { BrandVisualKit } from 'types'
import { PressableBrandAICard } from 'screens/BrandKits/components/BrandAICard/BrandAICard'
import { BrandStylePreview } from 'screens/BrandKits/components/BrandStandard/BrandStyleCard/BrandStylePreview'
import { Carousel } from 'components/Carousel/Carousel'

interface Props {
  onBrandKitChange: (voice?: number) => void
  selectedBrandKit?: number
}

export const BrandKitSelect = ({ onBrandKitChange, selectedBrandKit }: Props) => {
  const brandVisualKitsQuery = useBrandVisualKits()
  const brandVisualKits = brandVisualKitsQuery.data?.brand_visual_kits

  useEffect(() => {
    const latestBrandKit = brandVisualKits && brandVisualKits[brandVisualKits.length - 1]?.id

    if (brandVisualKitsQuery.isFetched && latestBrandKit && !selectedBrandKit) {
      onBrandKitChange(latestBrandKit)
    }
  }, [brandVisualKits]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!brandVisualKits) return null

  return (
    <Carousel>
      {brandVisualKits.map((kit) => (
        <BrandVisualKitCard
          key={kit.id}
          kit={kit}
          isSelected={kit.id === selectedBrandKit}
          onSelect={() => onBrandKitChange(kit.id)}
        />
      ))}
    </Carousel>
  )
}

const BrandVisualKitCard = ({
  kit,
  isSelected = false,
  onSelect,
}: {
  kit: BrandVisualKit
  isSelected?: boolean
  onSelect: () => void
}) => (
  <PressableBrandAICard
    preview={() => <BrandStylePreview kit={kit} />}
    onPress={() => onSelect()}
    isSelected={isSelected}
    title={kit.name}
  />
)
